/**
 * Shared attribute selection helpers for admin and storefront product forms.
 */

export function getProductSelectedAttributes(product) {
    const raw = product?.selectedAttributes || product?.attributes;
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};
    return raw;
}

export function getActiveAttributeValues(attribute) {
    return (attribute?.values || []).filter((value) => (value.status || 'active') === 'active');
}

export function flattenSelectedAttributes(attrs) {
    if (!attrs || typeof attrs !== 'object') return [];
    return Object.entries(attrs).flatMap(([name, data]) => {
        if (Array.isArray(data)) {
            return data.map((item) => ({
                name,
                value: typeof item === 'object' && item !== null ? item.value : String(item),
                // price field removed: attribute-level pricing is no longer supported
            }));
        }
        if (typeof data === 'object' && data !== null && 'value' in data) {
            return [{
                name,
                value: data.value,
                // price field removed: attribute-level pricing is no longer supported
            }];
        }
        if (data !== undefined && data !== null && data !== '') {
            return [{ name, value: String(data) }];
        }
        return [];
    });
}

export function pickSelectionsForDefinitions(definitions = [], selections = {}) {
    const picked = {};
    definitions.forEach((attribute) => {
        if (selections[attribute.name] !== undefined) {
            picked[attribute.name] = selections[attribute.name];
        }
    });
    return picked;
}

/**
 * Attribute-level price modifiers have been removed.
 * Pricing is managed at the product level (product.price, product.sizePrices).
 * This function is kept for interface compatibility but always returns 0.
 */
export function calculateAttributePriceTotal(_selections = {}) {
    return 0;
}

export function validateAttributeSelections(definitions = [], selections = {}) {
    for (const attribute of definitions) {
        const activeValues = getActiveAttributeValues(attribute);
        const selected = selections[attribute.name];
        const type = attribute.type || 'select';

        if (type === 'text') {
            const text = typeof selected === 'string' ? selected.trim() : '';
            if (!text) return `Please enter ${attribute.name}.`;
            continue;
        }

        if (type === 'checkbox') {
            continue;
        }

        if (activeValues.length === 0) continue;

        if (type === 'radio' || type === 'select') {
            const value = typeof selected === 'object' && selected !== null && 'value' in selected
                ? selected.value
                : selected;
            if (!value) return `Please select ${attribute.name}.`;
        }
    }
    return null;
}

export function buildSubcategoryContext(productData = {}) {
    if (!productData.subcategoryId && !productData.subcategory) return null;
    return {
        id: productData.subcategoryId || null,
        name: productData.subcategory || null,
    };
}
